<template>
    <div class="previewResumeBox">
        <div class="previewResume">
            <div class="infoBox clearfix">
                <div class="imgBox">
                    <img class="acartImg" :src="recruitResumeBaseResponse.avatar | imageUrl('',50,50)" alt="">
                    <img class="genderImg" :src="recruitResumeBaseResponse.gender == 1 ?'https://image.manamana.net/1657164336000_qqLGIZKL':'https://image.manamana.net/1657164354000_mZFYvNei'" alt="">
                </div>
                <div class="info">
                    <p class="title1">{{recruitResumeBaseResponse.name}}</p>
                    <p class="title2">{{getBirthday(recruitResumeBaseResponse.beginWorkTime)}}年  |  {{getEducation(recruitResumeBaseResponse.education)}}  |  {{getBirthday(recruitResumeBaseResponse.birthday)}}岁  |  {{getJobs(recruitResumeBaseResponse.jobStatus)}}</p>
                    <p class="title3"><i v-if="recruitResumeBaseResponse.mobile">电话：{{recruitResumeBaseResponse.mobile}}</i><i v-if="recruitResumeBaseResponse.email"><span>|</span>邮箱：{{recruitResumeBaseResponse.email}}</i><i v-if="recruitResumeBaseResponse.wechatLink"><span>|</span>微信：{{recruitResumeBaseResponse.wechatLink}}</i></p>
                </div>
            </div>
            <div class="contentBox">
                <p class="title">个人优势</p>
                <div class="htmlBox" v-html="getHtml(recruitResumeAdvantageResponse.advantage)"></div>
            </div>
            <div class="contentBox" v-if="recruitResumeExpectationResponses.length">
                <p class="title">求职期望</p>
                <div class="expectations" v-for="(item,i) in recruitResumeExpectationResponses" :key="i">
                    {{item.positionName}}<span>|</span>{{item.negotiable == 0 ? item.salaryBegin + 'K' + '-' + item.salaryEnd + 'K' : '面议'}}<span>|</span>{{item.cityName}}
                </div>
            </div>
            <div class="contentBox" v-if="recruitResumeWorkExperienceResponses.length">
                <p class="title">{{recruitResumeBaseResponse.idType == 1 ? '工作经历': '实习/工作经历'}}</p>
                <div class="experience" v-for="(item,i) in recruitResumeWorkExperienceResponses" :key="i">
                    <div class="experienceTitle clearfix"><p>{{item.companyName}}</p><span>{{item.workBeginTime | formatDate("YYYY.MM")}} - <i v-if="item.workEndTime">{{item.workEndTime | formatDate("YYYY.MM")}}</i><i v-else>至今</i></span></div>
                    <div class="experienceName">{{item.positionName}}</div>
                    <div class="htmlBox" v-html="getHtml(item.workContent)"></div>
                </div>
            </div>
            <div class="contentBox" v-if="recruitResumeProjectExperienceResponses.length">
                <p class="title">项目经历</p>
                <div class="experience" v-for="(item,i) in recruitResumeProjectExperienceResponses" :key="i">
                    <div class="experienceTitle clearfix"><p>{{item.projectName}}</p><span>{{item.projectCycleBegin | formatDate("YYYY.MM")}} - <i v-if="item.projectCycleEnd">{{item.projectCycleEnd | formatDate("YYYY.MM")}}</i><i v-else>至今</i></span></div>
                    <div class="experienceName">{{item.projectRole}}</div>
                    <div class="htmlBox" v-html="getHtml(item.projectDes)"></div>
                    <div class="htmlBox" v-html="getHtml(item.projectPerformance)"></div>
                    <div class="link" v-if="item.projectLink">项目链接：<a target="_blank" :href="item.projectLink">{{item.projectLink}}</a></div>
                </div>
            </div>
            <div class="contentBox" v-if="recruitResumeEducationExperienceResponses">
                <p class="title">教育经历</p>
                <div class="experience" v-for="(item,i) in recruitResumeEducationExperienceResponses" :key="i">
                    <div class="experienceTitle clearfix"><p>{{item.schoolName}}</p><span>{{item.schoolStartTime | formatDate("YYYY.MM")}} - <i v-if="item.schoolEndTime">{{item.schoolEndTime | formatDate("YYYY.MM")}}</i><i v-else>至今</i></span></div>
                    <div class="tags">{{getEducation(item.education)}}<span>|</span>{{item.major}}</div>
                </div>
            </div>
            <div class="contentBox" v-if="recruitResumeProductShowResponse.videoDomains.length">
                <p class="title">作品展示</p>
                <div class="videoList clearfix" v-for="(item,i) in recruitResumeProductShowResponse.videoDomains" :key="i">
                    <img :src="item.thumb | imageUrl('',277,160)" alt="">
                    <div class="videoInfo">
                        <p class="videoTitle">{{item.title}}</p>
                        <p class="tag"><span v-for="(tag,y) in item.categoryTagGroupInfoList" :key="y">{{tag}}</span></p>
                        <p class="videoLink"><a target="_blank" :href="'https://www.manamana.net/video/detail?id='+item.id">{{'https://www.manamana.net/video/detail?id=' + item.id}}</a></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="uploadFile"><span @click="uploadFile">下载简历</span></div>
    </div>
</template>
<script>
export default {
  name: "previewResume",
  data() {
    return {
      title: "我的简历",
      wordCss: null,
      list: [1, 2, 3],
      recruitResumeAdvantageResponse: {}, //个人优势
      recruitResumeBaseResponse: {}, //基本信息
      recruitResumeEducationExperienceResponses: [], //教育经历
      recruitResumeExpectationResponses: [], //求职期望
      recruitResumeProductShowResponse: {}, //作品展示
      recruitResumeProjectExperienceResponses: [], //项目经历
      recruitResumeWorkExperienceResponses: [], //工作经历
      positionName: "",
      name: "",
    };
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    language() {
      return this.$language();
    }
  },
  created() {
    this.getInfo();
    if (this.$route.query.positionName) {
      this.positionName = this.$route.query.positionName
    }
    if (this.$route.query.name) {
      this.name = this.$route.query.name
    }
  },
  methods: {
    getEducation(i) {
      if (i == 1) {
        return "其他";
      }
      if (i == 2) {
        return "大专";
      }
      if (i == 3) {
        return "本科";
      }
      if (i == 4) {
        return "硕士";
      }
      if (i == 5) {
        return "博士";
      }
    },
    getHtml(text) {
      let value = "";
      if (text) {
        value = text.replace(/(\r\n|\n|\r)/gm, "<br />");
      }
      return value;
    },
    getJobs(i) {
      if (i == 1) {
        return "随时入职";
      }
      if (i == 2) {
        return "考虑机会";
      }
      if (i == 3) {
        return "暂不考虑";
      }
    },
    getBirthday(strBirthday) {
      if(!strBirthday || strBirthday < 0) {
        return 0
      }
      let date = new Date(strBirthday);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let dd = date.getDate();
      dd = dd < 10 ? "0" + dd : dd;
      strBirthday = y + "-" + MM + "-" + dd;
      var returnAge;
      var strBirthdayArr = strBirthday.split("-");
      var birthYear = strBirthdayArr[0];
      var birthMonth = strBirthdayArr[1];
      var birthDay = strBirthdayArr[2];
      var d = new Date();
      var nowYear = d.getFullYear();
      var nowMonth = d.getMonth() + 1;
      var nowDay = d.getDate();

      if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0岁
      } else {
        var ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
          if (nowMonth == birthMonth) {
            var dayDiff = nowDay - birthDay; //日之差
            if (dayDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          } else {
            var monthDiff = nowMonth - birthMonth; //月之差
            if (monthDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          }
        } else {
          returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
        }
      }

      return returnAge; //返回周岁年龄
    },
    getEducation(i) {
      if (i == 1) {
        return "其他";
      }
      if (i == 2) {
        return "大专";
      }
      if (i == 3) {
        return "本科";
      }
      if (i == 4) {
        return "硕士";
      }
      if (i == 5) {
        return "博士";
      }
    },
    uploadFile() {
      setTimeout(()=>{
        if (this.positionName && this.name) {
          this.htmlToPdf("previewResume", this.positionName + "-" + this.name + "-MANA招聘");
        } else {
          this.htmlToPdf("previewResume", "我的简历");
        }
      },50)
    },
    getInfo() {
      this.$http
        .get("/api/u/recruit/resume/online/info/" + this.$route.params.id)
        .then(res => {
          if (res.code == "OK") {
            this.recruitResumeAdvantageResponse =
              res.data.recruitResumeAdvantageResponse;
            this.recruitResumeBaseResponse = res.data.recruitResumeBaseResponse;
            this.recruitResumeEducationExperienceResponses =
              res.data.recruitResumeEducationExperienceResponses;
            this.recruitResumeExpectationResponses =
              res.data.recruitResumeExpectationResponses;
            if (res.data.recruitResumeFileResponse.length) {
              for (
                let i = 0;
                i < res.data.recruitResumeFileResponse.length;
                i++
              ) {
                if (res.data.recruitResumeFileResponse[i].type == 1) {
                  this.resumeFile = res.data.recruitResumeFileResponse[i];
                }
                if (res.data.recruitResumeFileResponse[i].type == 2) {
                  this.videoFile = res.data.recruitResumeFileResponse[i];
                }
              }
            } else {
              this.resumeFile = null;
              this.videoFile = null;
            }
            this.recruitResumeProductShowResponse =
              res.data.recruitResumeProductShowResponse;
            // if (res.data.recruitResumeProductShowResponse.videoIds) {
            //   this.selectVideoList = res.data.recruitResumeProductShowResponse.videoIds.split(',');
            // }
            this.recruitResumeProjectExperienceResponses =
              res.data.recruitResumeProjectExperienceResponses;
            this.recruitResumeWorkExperienceResponses =
              res.data.recruitResumeWorkExperienceResponses;
          }
        });
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.clearfix:before,
.clearfix:after {
    content: '.';
    display: block;
    overflow: hidden;
    visibility: hidden;
    font-size: 0;
    line-height: 0;
    width: 0;
    height: 0;
}

.clearfix:after {
    clear: both;
}

.clearfix {
    zoom: 1;
}
.previewResumeBox{
    background: #fafafa;
    min-width: 1440px;
    padding-bottom: 200px;
}
.previewResumeBox .uploadFile{
    position: fixed;
    bottom: 0;
    width: 100%;
    min-width: 1440px;
    height: 120px;
    background: rgba(255,255,255,0.9);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.5);
    span{
        display: block;
        width: 346px;
        height: 44px;
        text-align: center;
        background: #2026CC;
        line-height: 44px;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        margin: 38px auto 0;
        cursor: pointer;
    }
}
.previewResumeBox .previewResume{
    width: 826px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    padding: 40px;
    box-sizing: border-box;
    margin: 0 auto;
}
.infoBox{
    margin-bottom: 40px;
}
.infoBox .info{
    float: left;
    width: 626px;
}
.infoBox .imgBox{
    float: left;
    position: relative;
    margin-right: 30px;
}
.infoBox .imgBox .acartImg{
    width: 88px;
    height: 88px;
    border-radius: 50%;
}
.infoBox .imgBox .genderImg{
    width: 25px;
    height: 25px;
    position: absolute;
    right: 0;
    bottom: 0;
}
.infoBox .info .title1{
    height: 30px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    line-height: 30px;
}
.infoBox .info .title1 span{
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    margin-left: 40px;
}
.infoBox .info .title2{
    height: 24px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    margin: 10px 0;
}
.infoBox .info .title3{
    height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
}
.infoBox .info .title3 span{
    margin: 0 10px;
}
.previewResume{
    .contentBox{
        margin-bottom: 40px;
        .title{
            height: 22px;
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            margin-bottom: 20px;
        }
        .htmlBox{
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            line-height: 24px;
        }
        .expectations{
            height: 38px;
            line-height: 38px;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            span{
                margin: 0 10px;
            }
        }
        .experience{
            margin-bottom: 20px;
            .experienceTitle{
                font-size: 14px;
                font-weight: 500;
                color: #333333;
                line-height: 22px;
                span{
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                    margin-left: 40px;
                }
                p{
                    float: left;
                    max-width: 70%;
                    max-height: 44px;
                    line-height: 22px;
                }
            }
            .experienceName{
                font-size: 12px;
                font-weight: 500;
                color: #333333;
                line-height: 18px;
                margin: 10px 0;
            }
            .link{
                margin-top: 10px;
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                color: #666666;
                line-height: 17px;
                a{
                    color: #2026CC;
                }
            }
            .tags{
                height: 18px;
                font-size: 12px;
                font-weight: 400;
                color: #666666;
                line-height: 18px;
                margin-top: 10px;
                span{
                    margin: 0 10px;
                }
            }
        }
        .videoList{
            margin-bottom: 20px;
            img{
                float: left;
                width: 130px;
                height: 82px;
                margin-right: 10px; 
            }
            .videoInfo{
                float: left;
                width: 604px;
                .videoTitle{
                    height: 22px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #0A0A0A;
                    line-height: 22px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .tag{
                    height: 18px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 18px;
                    margin: 10px 0;
                }
                .videoLink{
                    height: 18px;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 18px;
                    a{
                        color: #2026CC;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/previewResume.vue